/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyday calculators — percentages, BMI and BMR, age and date differences, loans, compound interest, SIP, GPA, fractions, tips and discounts.`)
};

const es_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras cotidianas — porcentajes, IMC y TMB, diferencias de edad y fecha, préstamos, interés compuesto, SIP, GPA, fracciones, propinas y descuentos.`)
};

const de_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alltagsrechner — Prozentsätze, BMI und BMR, Alters- und Datumsdifferenzen, Kredite, Zinseszins, SIP, Notendurchschnitt, Brüche, Trinkgelder und Rabatte.`)
};

const nl_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alledaagse rekentools — percentages, BMI en BMR, leeftijds- en datumverschillen, leningen, samengestelde rente, SIP, GPA, breuken, fooien en kortingen.`)
};

const fr_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrices du quotidien — pourcentages, IMC et MB, différences d’âge et de date, prêts, intérêts composés, SIP, moyenne générale, fractions, pourboires et remises.`)
};

const it_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatrici quotidiane — percentuali, BMI e BMR, differenze di età e data, prestiti, interesse composto, SIP, media voti, frazioni, mance e sconti.`)
};

const pt_br2_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras do dia a dia — porcentagens, IMC e TMB, diferenças de idade e data, empréstimos, juros compostos, SIP, média de notas (GPA), frações, gorjetas e descontos.`)
};

const pt_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras do dia a dia — percentagens, IMC e TMB, diferenças de idade e data, empréstimos, juro composto, SIP, média de notas, frações, gorjetas e descontos.`)
};

const ja_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常計算機 — パーセンテージ、BMIとBMR、年齢・日付差、ローン、複利、SIP、GPA、分数、チップと割引。`)
};

const zh_about_cat_calculators = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常计算器 — 百分比、BMI 和 BMR、年龄与日期差、贷款、复利、SIP、GPA、分数、小费与折扣。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_cat_calculators = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_cat_calculators(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_cat_calculators", locale)
	if (locale === "en") return en_about_cat_calculators(inputs)
	if (locale === "es") return es_about_cat_calculators(inputs)
	if (locale === "de") return de_about_cat_calculators(inputs)
	if (locale === "nl") return nl_about_cat_calculators(inputs)
	if (locale === "fr") return fr_about_cat_calculators(inputs)
	if (locale === "it") return it_about_cat_calculators(inputs)
	if (locale === "pt-BR") return pt_br2_about_cat_calculators(inputs)
	if (locale === "pt") return pt_about_cat_calculators(inputs)
	if (locale === "ja") return ja_about_cat_calculators(inputs)
	return zh_about_cat_calculators(inputs)
};